
const style = {
    background: "var(--highlight)",
    padding: "10px 14px",
    borderColor: "#EBEAE9",
    borderWidth: 1,
    borderStyle: "solid",
    borderRadius: 0,
    fontWeight: 600,
}

const ChartToolTip = ({ children }) => {

    return (
        <div style={style}>
            {children}
        </div>
    )
}

export default ChartToolTip;
